import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        console.log('qqq', queryParams)
        axios
          .get(`${baseURL}/api/Shop/Get`)
          .then(response => {
            console.log('response', response)

            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = 'shopCode',
              sortDesc = false,
              status,
            } = queryParams

            const queryLowered = q.toLowerCase()

            let dataFromAPI = response.data.data
            console.log('dataFromAPI 0 ', dataFromAPI)

            if (status) {
              dataFromAPI = dataFromAPI.filter(user => user.status == (status == 'active'))
            }

            console.log('dataFromAPI 1 ', dataFromAPI)

            if (q !== '' && q !== null) {
              const result = []
              dataFromAPI.forEach(x => {
                console.log(x)
                let shopName = x.shopName || ''
                let phone = x.phone || ''
                let email = x.email || ''
                let shopTypeName = x.shopTypeName || ''
                let shopCode = x.shopCode || ''

                if (shopName.includes(q)
                || phone.includes(q)
                || email.includes(q)
                || shopTypeName.includes(q)
                || shopCode.includes(q)) {
                  result.push(x)
                }
              })
              dataFromAPI = result
            }

            //console.log('dataFromAPI 2', dataFromAPI)

            const filteredData = dataFromAPI.filter(
              user => user.shopName,
              /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
            )

            const sortedData = filteredData.sort(sortCompare(sortBy))
            if (sortDesc) sortedData.reverse()

            resolve({
              data: paginateArray(sortedData, perPage, page),
              totalCount: filteredData.length,
            })
          })
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Shop/GetById`, {
            params: {
              shopId: id,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUserOld(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/user/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      console.log('UserData', userData)
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/User/AddOrUdpate`, { userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteShop(ctx, { id, status, commistion }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${baseURL}/api/Shop/Delete`, {
            params: {
              shopId: id,
              status,
              commission_rate: commistion,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
